function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-774 -424) translate(480 263) translate(140 161) translate(154.186 .86)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 21.093,
  cy: 20.735,
  fill: "#56AFEF",
  rx: 21.093,
  ry: 20.735
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M20.79 5.623l1.379 7.146c3.37.575 6.03 3.226 6.609 6.586l7.153 1.38-7.153 1.38c-.58 3.36-3.24 6.012-6.61 6.587l-1.377 7.146-1.378-7.146c-3.37-.575-6.03-3.226-6.61-6.586l-7.153-1.38 7.154-1.38c.134-.782.382-1.525.724-2.213l1.453 2.128c-.118.469-.18.96-.18 1.464 0 3.3 2.681 5.975 5.99 5.975 3.308 0 5.99-2.675 5.99-5.975s-2.682-5.974-5.99-5.974c-.494 0-.973.06-1.432.172l-2.122-1.464c.677-.33 1.408-.57 2.176-.7l1.378-7.146z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F54747",
  d: "M14.094 4.551L17.265 23.529 10.922 23.529z",
  transform: "rotate(-45 14.094 14.04)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F8D8D8",
  d: "M27.484 17.906L30.656 36.884 24.313 36.884z",
  transform: "rotate(135 27.484 27.395)"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 20.791,
  cy: 20.735,
  fill: "#FFF",
  rx: 3.171,
  ry: 3.163
}))))));

var SvgSafari = function SvgSafari(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 43,
    viewBox: "0 0 44 43",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSafari, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/safari.7dce1824.svg";
export { ForwardRef as ReactComponent };